// @ts-nocheck

import { DocumentInventoryService } from './documentInventoryService';
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../queries/useDataEngine';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../const/CommonConst';

const DOCUMENT_INVENTORY = 'documentInventory';

export const DOCUMENT_INVENTORY_QUERY_KEYS = {
  ALL: [DOCUMENT_INVENTORY],

  documentInventoryList: {
    ROOT: [DOCUMENT_INVENTORY, 'list'],
    key: (params = {}) => [DOCUMENT_INVENTORY, 'list', params],
  },

  advanceDocumentSearch: {
    ROOT: [DOCUMENT_INVENTORY, 'advanceSearch'],
    key: (params = {}) => [DOCUMENT_INVENTORY, 'advanceSearch', params],
  },

  documentMarkdown: {
    ROOT: [DOCUMENT_INVENTORY, 'markdown'],
    key: (params = {}) => [DOCUMENT_INVENTORY, 'markdown', params],
  },

  versionDetails: {
    ROOT: [DOCUMENT_INVENTORY, 'versionDetails'],
    key: (params = {}) => [DOCUMENT_INVENTORY, 'versionDetails', params],
  },

  tags: {
    ROOT: [DOCUMENT_INVENTORY, 'tags'],
    key: () => [DOCUMENT_INVENTORY, 'tags'],
  },

  documentLinkedEntities: {
    ROOT: [DOCUMENT_INVENTORY, 'linkedEntities'],
    key: (params = {}) => [DOCUMENT_INVENTORY, 'linkedEntities', params],
  },
};
const getDocumentInventoryWithCount = async (params, loader) => {
  const response = await DocumentInventoryService.getAllDocumentInventory(
    params,
    loader
  );

  const countHeader =
    response?.headers?.get?.('count') || response?.headers?.count;

  return {
    data: {
      items: response?.data || EMPTY_ARRAY,
      totalCount: Number(countHeader || 0),
    },
  };
};

export const useDocumentInventoryListQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DOCUMENT_INVENTORY_QUERY_KEYS.documentInventoryList.key,
    getDocumentInventoryWithCount,
    params,
    options
  );

const advanceDocumentSearchWithCount = async (params, loader) => {
  const response = await DocumentInventoryService.advanceDocumentSearch(
    params,
    loader
  );

  const countHeader =
    response?.headers?.get?.('count') || response?.headers?.count;

  return {
    data: {
      items: response?.data || EMPTY_ARRAY,
      totalCount: Number(countHeader || 0),
    },
  };
};

export const useAdvanceDocumentSearchQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DOCUMENT_INVENTORY_QUERY_KEYS.advanceDocumentSearch.key,
    advanceDocumentSearchWithCount,
    params,
    options
  );

export const useDocumentSftpSyncMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(DocumentInventoryService.documentSftpSync, {
    ...options,

    invalidateQueries: [
      DOCUMENT_INVENTORY_QUERY_KEYS.documentInventoryList.ROOT,
    ],
  });
};

export const useRollbackDocumentMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(DocumentInventoryService.rollbackDocument, {
    ...options,

    invalidateQueries: [DOCUMENT_INVENTORY_QUERY_KEYS.ALL],
  });
};

export const useDownloadDocumentMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useMutationEngine(DocumentInventoryService.downloadDocument, {
    ...options,
  });

export const useDocumentMarkdownQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DOCUMENT_INVENTORY_QUERY_KEYS.documentMarkdown.key,
    DocumentInventoryService.getDocumentMarkdown,
    params,
    options
  );

export const useVersionDetailsQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DOCUMENT_INVENTORY_QUERY_KEYS.versionDetails.key,
    DocumentInventoryService.getVersionDetails,
    params,
    options
  );

export const useSaveAsNewVersionMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(DocumentInventoryService.saveAsNewVersion, {
    ...options,

    invalidateQueries: [DOCUMENT_INVENTORY_QUERY_KEYS.ALL],
  });
};

export const useDeleteDocumentMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(DocumentInventoryService.deleteDocument, {
    ...options,

    invalidateQueries: [
      DOCUMENT_INVENTORY_QUERY_KEYS.documentInventoryList.ROOT,
    ],
  });
};

export const useUpdateDocumentMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(DocumentInventoryService.updateDocument, {
    ...options,

    invalidateQueries: [DOCUMENT_INVENTORY_QUERY_KEYS.ALL],
  });
};

export const useDocumentTagsQuery = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DOCUMENT_INVENTORY_QUERY_KEYS.tags.key,
    DocumentInventoryService.getTags,
    EMPTY_OBJECT,
    options
  );

export const useDocumentLinkedEntitiesQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DOCUMENT_INVENTORY_QUERY_KEYS.documentLinkedEntities.key,
    DocumentInventoryService.getDocumentLinkedEntities,
    params,
    options
  );

export const useUpdateDocumentLinkedEntitiesMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(
    DocumentInventoryService.updateDocumentLinkedEntities,
    {
      ...options,

      invalidateQueries: [
        DOCUMENT_INVENTORY_QUERY_KEYS.documentLinkedEntities.ROOT,
      ],
    }
  );
};
